jQuery(document).ready(function($) {
	 $('.footer-container .mobile-nav-dropdown-btn').each(function(index) {
		$(this).click(function(event) {
			$('.footer-container .mobile-nav-dropdown-btn.open').not(this).removeClass('open');
			$(this).toggleClass('open');
			var drop = $(this).next('ul');
			//console.log($(this).next('ul'));
			$('.footer-container .footer-nav-dropdown.active').not(drop).removeClass('active');
			$(drop).toggleClass("active");
		});
	 });
});
